// extracted by mini-css-extract-plugin
module.exports = {"title":"formFactory_title__3YNIg","form-content":"formFactory_form-content__2_xqu"};